<template>
  <div id="editbank">
    <nav-common></nav-common>
    <div class="addbanks-content">
      <el-form ref="form" v-loading="loading" label-width="150px">
        <el-form-item label="姓名">
          <el-input v-model="cardinfo.username"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号码">
          <el-input v-model="cardinfo.bank_account"></el-input>
        </el-form-item>
        <el-form-item label="银行卡所属银行">
          <el-input v-model="cardinfo.bank_name"></el-input>
        </el-form-item>
        <el-form-item label="银行卡开户支行">
          <el-input v-model="cardinfo.bank_branch"></el-input>
        </el-form-item>
        <el-form-item label="添加银行卡照片">
          <el-upload
            class="upload-demo"
            action="1"
            :before-upload="bankUpload"
            :before-remove="handleRemove"
            list-type="picture"
            :file-list="cardinfo.file"
            >
            <el-button size="small" type="primary">点击修改银行卡照片</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <div class="btn-box">
          <el-button size="small" type="primary" @click="addbanks()">保存银行卡信息</el-button>
        </div>
        <div class="btn-box">
          <el-button size="small" type="warning" @click="back()">返回用户中心</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import NavCommon from '@/components/navtop/navcommon'

export default {
  name: 'Editbank',
  data () {
    return {
      loading: false,
      cardinfo: {
      }
    }
  },
  created() {
    this.getBankinfo();
  },
  methods: {
    bankUpload(file) {
      this.cardinfo.file = file;
      this.$message.success('银行卡照片上传成功，保存后方可预览');
    },
    handleRemove(file, fileList) {
      this.$message.error('不支持删除操作，点击按钮可重新上传照片');
      return false;
    },
    getBankinfo() {
      this.cardinfo = this.$route.query.cardinfo;
      this.cardinfo.file = [{
        name: '银行卡照片',
        url: this.cardinfo.bank_img
      }]
    },
    addbanks() {
      this.loading = true;
   		var formData = new FormData();
      var _this = this;
      var _from = _this.cardinfo;
  		formData.append("username",_from.username);
  		formData.append("bank_name",_from.bank_name);
  		formData.append("bank_account",_from.bank_account);
  		formData.append("bank_branch",_from.bank_branch);
  		formData.append("file", _from.file);
  		formData.append("id", _from.id);
  		this.$http({
  			method: 'post',
  			url: _this.$api + '/service/agent/user/save_card',
  			data: formData
  		}).then(function(res){
        _this.loading = false;
  			if(res.data.code == 200) {
          _this.$message.success(res.data.data);
				  _this.$router.go(-1);
  			} else {
          _this.$message.error(res.data.data);
  			}
  		})
  	},
    back() {
      this.$router.go(-1);
    }
  },
  components: {
    NavCommon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  #editbank
    .addbanks-content
      position relative
      margin 20px
      padding 60px 40px 20px 40px
      background #f8f8f8
      box-shadow 3px 3px 3px #f5f5f5 inset
      .el-form
        width 50%
      .btn-box
        margin: 15px auto
        text-align: center
</style>




// WEBPACK FOOTER //
// src/components/banks/editbank.vue